import { useQuery } from '@tanstack/react-query';
import { tenantApi } from './api-client';
import { useAuth } from './auth-context';

/** BUI's own workspace slug — mirrors `apps/api/src/auth/middleware.ts`'s `BUI_STAFF_TENANT_SLUG`. */
const BUI_STAFF_TENANT_SLUG = 'bui';
const BUI_STAFF_ROLES = new Set(['owner', 'admin']);

/**
 * Purely a nav-visibility check (the Admin Console link, the AppShell banner) — NOT a security
 * boundary. Every `/v1/admin/*` call is independently re-checked server-side by
 * `requireBuiStaff`, which is what actually enforces this; hiding a link here is only ever a UX
 * nicety, never the thing standing between a customer tenant and the console.
 */
export function useIsBuiStaff(): boolean {
  const { principal } = useAuth();
  const tenantQuery = useQuery({
    queryKey: ['tenant', 'me'],
    queryFn: () => tenantApi.me(),
    enabled: principal !== null,
  });
  const slug = tenantQuery.data?.tenant.slug;
  return slug === BUI_STAFF_TENANT_SLUG && principal?.role !== undefined && BUI_STAFF_ROLES.has(principal.role);
}
